    <!-- DeviceMonitor 采集点监控 -->
<template>
  <div>
    <!-- 表头 -->
    <div class="deviceMonitor">
      <div class="deviceMonitor_return" @click="returnClick()">
        <i class="el-icon-arrow-left fl"></i>
        <span class="fl">返回</span>
      </div>
      <h1>采集点监控</h1>
      <div class="deviceMonitor_time clearfix">
        <i class="el-icon-date fl"></i>
        <span class="fl">{{ dataTime }}</span>
        <span class="fl">{{ textTime }}</span>
      </div>
    </div>

    <!-- 查询条件 -->
    <div class="deviceMonitor_query">
      <div class="query_list clearfix fl" v-show="options.length">
        <span class="fl">归属机构：</span>
        <el-cascader
          class="fl"
          :clearable="true"
          v-model="value"
          :checkStrictly="true"
          :options="options"
          placeholder="系统管理机构"
          filterable
          :props="{ expandTrigger: 'hover', checkStrictly: true }"
          @change="handleChange"
        ></el-cascader>
      </div>

      <div class="query_list clearfix fl">
        <span class="fl">采集点：</span>
        <el-select v-model="deviceId" clearable placeholder="请选择">
          <el-option
            v-for="item in deviceList"
            :key="item.value"
            :label="item.deviceName"
            :value="item.deviceId"
          >
          </el-option>
        </el-select>
      </div>

      <div class="query_list clearfix fl">
        <span class="fl">在线状态：</span>
        <el-select clearable v-model="stateVal" placeholder="请选择">
          <el-option
            v-for="item in stateList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div class="query_list clearfix fl">
        <span class="fl">警报状态：</span>
        <el-select clearable v-model="alarmVal" placeholder="请选择">
          <el-option
            v-for="item in alarmList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <el-button type="primary" @click="queryClick()" icon="el-icon-search">
        查询
      </el-button>
    </div>

    <!-- 数据展示 -->
    <div class="deviceMonitor_content">
      <div class="deviceMonitor_title">
        <el-row>
          <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
            <div class="">状态</div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="">归属机构</div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="">采集点</div>
          </el-col>
          <el-col :xs="13" :sm="13" :md="13" :lg="13" :xl="13">
            <div class="">环境数据</div>
          </el-col>
          <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
            <div class="">警报</div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="">最后通信时间</div>
          </el-col>
        </el-row>
      </div>

      <div v-show="dataList.length > 0">
        <div
          class="deviceMonitor_list"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <el-row>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
              <div class="deviceMonitor_tab">
                <i
                  class="el-icon-s-data"
                  :style="{
                    fontSize: '22px',
                    color: item.online == 1 ? '#70FC79' : '#999999',
                  }"
                  :title="item.online == 1 ? '在线' : '离线'"
                ></i>
              </div>
            </el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
              <div class="deviceMonitor_tab">{{ item.deptName }}</div>
            </el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
              <div class="deviceMonitor_tab">{{ item.deviceName }}</div>
            </el-col>
            <el-col :xs="13" :sm="13" :md="13" :lg="13" :xl="13">
              <div class="deviceMonitor_tab">{{ item.dataText }}</div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
              <div class="deviceMonitor_tab">
                <i
                  class="el-icon-s-opportunity"
                  :style="{
                    fontSize: '22px',
                    color: item.warning == 0 ? '#70FC79' : '#F8352E',
                  }"
                  :title="item.warning == 0 ? '正常' : '警报'"
                ></i>
              </div>
            </el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
              <div class="deviceMonitor_tab">{{ item.lastCommunicated }}</div>
            </el-col>
          </el-row>
        </div>
        <div class="deviceMonitor_btn">
          <span>共{{ total }}条数据</span>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="total"
            background
          >
          </el-pagination>
        </div>
      </div>

      <div v-show="dataList.length == 0">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
// 引入日期时间
import { dateTime } from "../../assets/js/data";
export default {
  data() {
    return {
      // 定时器
      timer: "",
      // 日期时间
      dataTime: "",
      // 星期
      textTime: "",

      // 机构树
      options: [],
      // 当前选择机构
      value: [],
      // 当前机构ID
      deptId: "",

      // 采集点LIST
      deviceList: [],
      // 当前采集点ID
      deviceId: "",

      //   在线状态
      stateVal: "",
      //   在线状态LIST
      stateList: [
        {
          value: "0",
          label: "离线",
        },
        {
          value: "1",
          label: "在线",
        },
      ],
      //   警报状态
      alarmVal: "",
      //   警报状态LIST
      alarmList: [
        {
          value: "0",
          label: "正常",
        },
        {
          value: "1",
          label: "警报",
        },
      ],

      // 数据列表
      dataList: [],
      // 当前页数
      page: 1,
      // 总数据数
      total: 0,

      // 查询list
      queryList: {
        deptId: "",
        deviceName: "",
        alarmVal: "",
        stateVal: "",
        page: 1,
      },
    };
  },
  created() {
    //   日期时间赋值
    this.dataTime = dateTime();
    //   清除定时器
    window.clearInterval(this.timer);
    let _this = this;
    // 定时更新时间
    this.timer = setInterval(() => {
      _this.dataTime = dateTime();
    }, 1000);

            let date = new Date();
    let num = date.getDay();
    if (num == 0) {
      this.textTime = "星期天";
    }
    if (num == 1) {
      this.textTime = "星期一";
    }
    if (num == 2) {
      this.textTime = "星期二";
    }
    if (num == 3) {
      this.textTime = "星期三";
    }
    if (num == 4) {
      this.textTime = "星期四";
    }
    if (num == 5) {
      this.textTime = "星期五";
    }
    if (num == 6) {
      this.textTime = "星期六";
    }

    // 获取机构树
    this.options = JSON.parse(localStorage.getItem("structure"));

    this.HJ212Records(" ");
    // 调用采集点监控
    this.DeviceMonitor(this.queryList);
  },
  methods: {
    //   查询数据
    queryClick() {
      this.page = 1;

      let val = JSON.parse(JSON.stringify(this.value));
      if (val.length >= 1) {
        this.queryList.deptId = val[val.length - 1];
      } else {
        this.queryList.deptId = "";
      }

      if (this.deviceId !== "") {
        for (let i = 0; i < this.deviceList.length; i++) {
          if (this.deviceId == this.deviceList[i].deviceId) {
            this.queryList.deviceName = this.deviceList[i].deviceName;
          }
        }
      }

      this.queryList.stateVal = this.stateVal;
      this.queryList.alarmVal = this.alarmVal;
      this.queryList.page = 1;

      // 调用采集点监控
      this.DeviceMonitor(this.queryList);
    },
    // 采集点监控
    DeviceMonitor(queryList) {
      // 获取loginToken
      let loginToken = localStorage.getItem("loginToken");

      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DeviceMonitor",
          option: "FRESH_DATA",
          online: queryList.stateVal,
          warning: queryList.alarmVal,
          deptId: queryList.deptId,
          deviceName: queryList.deviceName,
          leader: "",
          hj212: "1",
          page: queryList.page,
          loginToken,
        },
      })
        .then((res) => {
          // 登录超时
          if (res.data._STATUS == "0") {
            this.dataList = res.data.list;
            this.total = res.data.rowsCount;
          }else{
            
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取机构下的采集点
    HJ212Records(deptId) {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "HJ212Records",
          deptId:deptId,
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            if (res.data.devices.length > 0) {
              this.deviceList = res.data.devices;
            }
          }else{
            
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 现在所属机构
    handleChange(value) {
      if (value.length == 0) {
        this.patchLists = [];
      }
      this.deviceId = "";
      let val = JSON.parse(JSON.stringify(value));
      if (val.length >= 1) {
        this.deptId = val[val.length - 1];
      } else {
        this.deptId = "";
      }
      // 获取机构下的采集点
      this.HJ212Records(this.deptId);
    },
    // 选择分页
    handleCurrentChange(val) {
      this.queryList.page = val;
      // 调用采集点监控
      this.DeviceMonitor(this.queryList);
    },
    // 返回上一级
    returnClick() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
// 表头
.deviceMonitor {
  width: 100%;
  height: 50px;
  background-color: #304156;
  position: relative;
  h1 {
    min-width: 300px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 26px;
    letter-spacing: 6px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  .deviceMonitor_return {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    overflow: hidden;
    line-height: 50px;
    color: #fff;
    &:hover {
      cursor: pointer;
      text-shadow: #000 0 0 2px;
    }
    i {
      font-weight: bold;
      margin-left: 20px;
      font-size: 20px;
      line-height: 52px;
    }
    span {
      line-height: 50px;
      font-size: 20px;
    }
  }
  .deviceMonitor_time {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    padding: 0 20px;
    color: #fff;
    i {
      font-size: 32px;
      line-height: 50px;
    }
    span {
      margin: 0 20px;
      font-size: 28px;
      line-height: 50px;
    }
  }
}

// 查询条件
.deviceMonitor_query {
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;
  .query_list {
    height: 46px;
    line-height: 40px;
    margin-right: 20px;
  }
}

// 数据展示
.deviceMonitor_content {
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;

  .deviceMonitor_title {
    width: 100%;
    text-align: center;
    color: #fff;
    height: 40px;
    line-height: 40px;
    background-color: #545c64;
  }

  .deviceMonitor_list {
    width: 100%;
    text-align: center;
    &:nth-child(2n-1) {
      background-color: #f0faff;
    }
    .deviceMonitor_tab {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #333;
      min-height: 40px;
    }
  }

  .deviceMonitor_btn {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      margin: 0 20px;
      color: #666666;
    }
  }
}
</style>